export const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClass = {
    sm: 'spinner-sm',
    md: '',
    lg: 'spinner-lg'
  }[size];

  return (
    <div className={`spinner ${sizeClass} ${className}`} />
  );
};

export default LoadingSpinner;
